import { createSelector } from '@ngrx/store';
import { cloneDeep, get } from 'lodash';

import { AuthSelectors } from '@lockton-apps/shared/data-access/auth';
import { PortalConfigSelectors } from '@lockton-apps/shared/data-access/portal-config';
import { Role } from '@lockton-apps/shared/interfaces';
import {
  defaultFooterLinks,
  defaultPrimaryNavBrokerLinks,
  defaultPrimaryNavContactLinks,
  userMenuMap,
} from '@lockton-apps/shared/util/constants';

export const selectPrimaryNav = createSelector(
  PortalConfigSelectors.selectActivePortalConfig,
  AuthSelectors.getRole,
  (activePortalConfig, role) => {
    switch (role) {
      case Role.Administrator:
        return defaultPrimaryNavBrokerLinks;
      case Role.LeadBroker:
      case Role.Broker:
        return cloneDeep(
          get(
            activePortalConfig,
            'navigation.primaryBroker',
            defaultPrimaryNavBrokerLinks
          )
        );
      default:
        return cloneDeep(
          get(
            activePortalConfig,
            'navigation.primaryContact',
            defaultPrimaryNavContactLinks
          )
        );
    }
  }
);

export const selectUserMenu = createSelector(
  AuthSelectors.getRole,
  AuthSelectors.getIsPrimaryContact,
  PortalConfigSelectors.selectActivePortalConfig,
  (role, isPrimaryContact, activePortalConfig) => {
    const r =
      isPrimaryContact &&
      !activePortalConfig?.other?.disableManageContactAsClient
        ? 'PrimaryContact'
        : role;
    return userMenuMap.get(r || Role.Contact);
  }
);

export const selectFooterNav = createSelector(
  PortalConfigSelectors.selectActivePortalConfig,
  (activePortalConfig) => {
    return get(activePortalConfig, 'navigation.footer', defaultFooterLinks);
  }
);
